import { TicketingNotificationFilterTypes } from "@avenueops/frontend-shared";
import { ClientIntegration, ClientIntercomIntegration, ManualNotificationType } from "@avenueops/shared-types";
import { ClientInboxNotification } from "@avenueops/shared-types/src";
import { SmartForm } from "@avenueops/web-components";
import { NotificationType } from "@prisma/client";
import CustomNotifications from "components/monitors/editFormReboot/CustomNotifications";
import CustomNotificationsAndSignals from "components/monitors/editFormReboot/CustomNotificationsAndSignals";
import { useFormContext, useWatch } from "react-hook-form";
import { trpc2 } from "utils/trpc";

interface Props {
  notificationPrefix: string;
  disableCustomize?: boolean;
  notionIntegrations: ClientIntegration[];
}

export function NotionNotificationInput({ notificationPrefix, disableCustomize, notionIntegrations }: Props) {
  const notification: ManualNotificationType = useWatch({ name: notificationPrefix });

  const { watch } = useFormContext();

  const { data: notionParentOptions } = trpc2.v2.notion.getNotionPagesAndDatabases.useQuery(
    { integrationId: notification.integrationId },
    { enabled: notification.manualType === NotificationType.NOTION && !!notification.integrationId }
  );

  const useMappingOverride = watch(`${notificationPrefix}.useMappingOverride`);

  return (
    <>
      <div className="col-span-4">
        <SmartForm.DropdownSelect
          name={`${notificationPrefix}.integrationId`}
          title="Notion Instance"
          options={notionIntegrations.map((integration: ClientIntegration) => ({
            label: integration.name ?? "Notion workspace",
            value: integration.integrationId,
          }))}
        />
        <div className="pt-5">
          <SmartForm.DropdownSelect
            name={`${notificationPrefix}.recipientValue`}
            title="Notion Page or Database"
            options={notionParentOptions ?? []}
            disabled={notionParentOptions === undefined || notionParentOptions.length === 0}
            placeholder={
              notionParentOptions === undefined || notionParentOptions.length === 0 ? "No data for selected Notion instance" : "Notion page or database"
            }
          />
        </div>
      </div>
      {disableCustomize ? null : useMappingOverride ? (
        <div className="col-span-6">
          <CustomNotifications
            notificationPrefix={notificationPrefix}
            supportedTypes={TicketingNotificationFilterTypes}
            notificationType={notification.manualType}
          />
        </div>
      ) : (
        <div className="col-span-6">
          <CustomNotificationsAndSignals
            notificationPrefix={notificationPrefix}
            notificationType={notification.manualType}
            supportedTypes={TicketingNotificationFilterTypes}
          />
        </div>
      )}
    </>
  );
}
